import { HTMLAttributes } from 'react';
import styled from 'styled-components';

export const GuidesList = styled.ul`
    margin-bottom: 18px;
`;

export const GuidesListItem = styled.li<HTMLAttributes<HTMLLIElement>>`
    margin-bottom: 12px;
`;
